import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const Message = ({ message, literal, intl }) => {
  if (!message || !message?.id) {
    return '';
  }

  if (literal) {
    return intl.formatMessage(message, message.values);
  }

  return <FormattedMessage {...message} />;
};

Message.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
    values: PropTypes.object,
  }),
  values: PropTypes.object,
  literal: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(Message);
